import { Component, OnInit } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { DialogRef, DialogContentBase } from '@progress/kendo-angular-dialog';
import { GridDataResult } from '@progress/kendo-angular-grid';
import * as svgIcons from '@progress/kendo-svg-icons';

import { ProductComponentService } from '../product-component.service';
import { ProductItemService } from '../../product-item/product-item.service';
import { GridService } from 'src/app/shared/grid.service';
import { UtilService } from 'src/app/shared/util.service';

@Component({
  selector: 'app-product-component-popup',
  templateUrl: './product-component-popup.component.html',
  styleUrls: ['./product-component-popup.component.scss'],
})
export class ProductComponentPopupComponent extends DialogContentBase implements OnInit {
  public allIcons = svgIcons;
  
  public title = "module.product-component.popup.title_customer";
  public productId: number = 0;
  public customerId: number = 0;
  public userGroupHeaderId: number = 0;
  public isUserGroupComponent: boolean = false;
  public warnCustomerComponentExists: boolean = false;
  public skipCustomerComponent: boolean = false;
  public skipCustomerComponentLineId: number = 0;
  public lastQuantity: number = 0;

  isLoading = false;
  gridView!: GridDataResult;
  id!: number;
  
  pageable = {
    pageSizes: this.gridService.pageSizes,
  };

  public state: State = {
    take: this.gridService.take,
    skip: 0,
  };

  constructor(
    public override dialog: DialogRef,
    public gridService: GridService,
    private productComponentService: ProductComponentService,
    private productItemService: ProductItemService,
    private utilService: UtilService
  ) {
    super(dialog);
  }

  ngOnInit(): void {
    this.refresh();
    this.isUserGroupComponent = this.userGroupHeaderId > 0;
    if (this.isUserGroupComponent) {
      //set title
      this.title = "module.product-component.popup.title_usergroup";
      // check if a customer component already exists for this user group
      this.productComponentService.odataStr({}, `&$filter=CustomerId eq ${this.customerId} and UserGroupHeaderId eq null and ProductId eq ${this.productId}`).subscribe( response => {
        if (response.value.length > 0) {
          this.warnCustomerComponentExists = true;
        }
      })
    }
  }

  cancel() {
    this.dialog.close(false);
  }

  refresh() {
    // batir la requête OData
    let odataQuery = '$select=productComponentId,customerId,userGroupHeaderId,productId,productComponentOrder,lineDescription01,childProductComponentType,childProductItemId,childQuantityMultiplicator,includePriceInParent&$expand=childProductItem($select=productItemNumber,productItemTitleFr,productItemTitleEn)&$orderby=ProductComponentOrder asc';
    odataQuery += `&$filter=productId eq ${this.productId}`;
    if (this.customerId > 0) {
      odataQuery += ` and CustomerId eq ${this.customerId}`;
    }
    // usergroup : pour les composants Customer il faut spécifier que le userGroupHeaderId est null
    if (this.userGroupHeaderId > 0) 
      odataQuery += ` and UserGroupHeaderId eq ${this.userGroupHeaderId}`;
    else   
      odataQuery += ` and UserGroupHeaderId eq null`;

    // fetch customer product components
    this.isLoading = true;
    this.productComponentService.odataStr(this.state, odataQuery).subscribe( response => {
      this.isLoading = false;
      this.gridView = {
        data: response.value,
        total: response['@odata.count'],
      };
      // check if SKIP CUSTOMER COMPONENTS exists
      var skipCustomerProductComponent = response.value.find((item: any) => item.childProductComponentType === 'SkipCustomerProductComponent');
      if (skipCustomerProductComponent) {
          this.skipCustomerComponentLineId = skipCustomerProductComponent.productComponentId;
          this.skipCustomerComponent = true;
      }
      else {
        this.skipCustomerComponentLineId = 0;
        this.skipCustomerComponent = false;
      }
    })
  }

  dataStateChange(state: State) {
    this.isLoading = true;
    this.gridService.setRowPerPages(state);
    this.state = state;
    this.productComponentService.odata(this.state).subscribe((response) => {
      this.isLoading = false;
      this.gridView = {
        data: response.value,
        total: response['@odata.count'],
      };
    });
  }

  delete(dataItem: any) {
    this.productComponentService.delete(dataItem.productComponentId).subscribe(() => {
      this.refresh();
    });
  }

  deleteSkipCustomerComponent() {
    this.productComponentService.delete(this.skipCustomerComponentLineId).subscribe(() => {
      this.refresh();
    });
  }

  // ajoute un composant NOTE

  addNote() {
    let postData = {
      childProductComponentType: 'AddCommentToParent',
      customerId: this.customerId,
      userGroupHeaderId: this.userGroupHeaderId,
      productId: this.productId,
    };
    this.isLoading = true;
    this.productComponentService.create(postData).subscribe((response) => {
      this.refresh();
    });
  }

  // ajoute un composant PRODUITx

  addProductItem() {
    this.productItemService.popup().subscribe((data: any) => {
      if (data) {
        let postData = {
          childProductComponentType: 'AddProductItemInNewLine',
          customerId: this.customerId,
          userGroupHeaderId: this.userGroupHeaderId,
          productId: this.productId,
          childProductItemId: data.productItemId,
        };
        this.isLoading = true;
        this.productComponentService.create(postData).subscribe((response) => {
          this.refresh();
        });
      }
    });
  }

  // ajoute un composant SKIP CUSTOMER COMPONENTS

  addSkipCustomerComponent() {
    this.utilService.confirm('module.product-component.popup_add_skip_customer_component.title', 'module.product-component.popup_add_skip_customer_component.message', 'module.product-component.popup_add_skip_customer_component.button_yes','module.product-component.popup_add_skip_customer_component.button_no').subscribe((result: any) => {
      if (result) {
        let postData = {
          childProductComponentType: 'SkipCustomerProductComponent',
          customerId: this.customerId,
          userGroupHeaderId: this.userGroupHeaderId,
          productId: this.productId,
        };
        this.isLoading = true;
        this.productComponentService.create(postData).subscribe((response) => {
          this.refresh();
        });
      }
    });

  }

  update(dataItem: any, $event: any) {
    // ne pas updater et alerter si c'est un produit et que la quantité est < 1 
    if (dataItem.childProductComponentType == "AddProductItemInNewLine" && dataItem.childQuantityMultiplicator < 1) {
      this.utilService.alert('module.product-component.popup_error_quantity.title','module.product-component.popup_error_quantity.message');
      dataItem.childQuantityMultiplicator = this.lastQuantity;
    }
    else {
      this.productComponentService.update(dataItem).subscribe((response) => {
        this.refresh();
      });
    }
    
  }

  // change l'ordre d'un composant up/down (reassigne tous les ProductComponentOrder de ce groupe dans le backend)

  changeOrder(dataItem: any, facteur: number) {
    // trouver l'index de l'élément dans la liste
    const currentOrder = this.gridView.data.findIndex((item) => item.productComponentId === dataItem.productComponentId) + 1;
    dataItem.productComponentOrder = currentOrder + facteur;
    this.isLoading = true;
    this.productComponentService.changeOrder(dataItem).subscribe((response) => {
      this.isLoading = false;
      this.refresh();
    });
  }

  showCustomerComponent() {
    this.productComponentService.popup(this.productId, this.customerId, 0).subscribe((data: any) => {
    });
  }

}
